/* GOLDZENN engagement-ring PDP — Concept B "Visual playground" (UPDATE 4, 2026-10-21).
   Reads everything from the section's [data-er-json] (real variants + metafields). Never invents a price, a shape or a claim:
   - price = the matching variant's price (UPDATE 6: no quick picks; one simple column on phones: photo -> shape -> carat -> gold -> quality -> price)
   - shapes = custom.shape_siblings products that resolved and have a price (other products, never a borrowed price)
   - modes "On the hand" / "Compare sizes" only when on-hand images / a carat chart exist (no drawings)
   - certificate / stone type / made-to-order / ship-by only when the product metafields say so
   - UPDATE 16 (2026-10-22): "360°" button = supplier turntable MP4 for the selected gold colour (custom.turntable_videos;
     legacy custom.supplier_turntable_video as fallback); photo-size caption from custom.photo_center_ct
   - UPDATE 18 (2026-10-22): leaving the 360 (the button, now "Photos" while on; a swipe; another view) returns to the photo angle the
     shopper left, for the CURRENT selection; selected gold without a video -> the white one (then yellow, rose) with a caption;
     borrowed turntables (custom.turntable_source_shape) get "360° view shown with an emerald center." */
(function () {
  'use strict';
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const COLOR_LABEL = { Y: 'Yellow gold', W: 'White gold', R: 'Rose gold' };
  const ICON = {
    shield: '<path d="M12 2.5 19 5v6c0 4.6-3 8.3-7 10-4-1.7-7-5.4-7-10V5z"/><path d="m8.5 12 2.4 2.4 4.6-4.8"/>',
    doc: '<path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M10 12h5M10 16h5"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    ret: '<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4h4"/>'
  };
  const svg = (k) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true">${ICON[k]}</svg>`;

  function init(root) {
    const G = window.GZ;
    const J = JSON.parse(root.querySelector('[data-er-json]').textContent);
    const P = J.product, ST = J.settings || {}, V = J.variants || [];
    const $ = (s, r = root) => r.querySelector(s);
    const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desk = () => matchMedia('(min-width: 1024px)').matches;
    const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const qs = new URLSearchParams(location.search);

    /* ---------- option roles ---------- */
    const roles = P.options.map((n) => G.roleOf(n));
    let iC = roles.indexOf('carat'), iQ = roles.indexOf('quality'), iM = roles.indexOf('metal');
    let metals = iM >= 0 ? P.values[iM].map((v) => ({ v, c: G.colourOf(v), k: G.karatOf(v) })) : [];
    if (iM >= 0 && metals.some((x) => !x.c)) { roles[iM] = 'other'; iM = -1; metals = []; }
    const colors = ['Y', 'W', 'R'].filter((c) => metals.some((x) => x.c === c));
    const karats = [...new Set(metals.map((x) => x.k).filter(Boolean))].sort();
    let carats = iC >= 0 ? P.values[iC].map((v) => ({ v, n: G.caratNum(v) })) : [];
    if (iC >= 0 && carats.some((x) => x.n == null)) { roles[iC] = 'other'; iC = -1; carats = []; }
    carats.sort((a, b) => a.n - b.n);
    const qualities = iQ >= 0 ? P.values[iQ] : [];
    const shape = G.shapeKey(P.shape) || G.shapeKey(P.title);
    const shapeName = shape ? G.SHAPES[shape].label : (P.shape || '');
    const stone = P.stoneType ? String(P.stoneType) : '';

    /* ---------- state ---------- */
    let cur = V.find((v) => v.id === J.selected) || V[0];
    const sel = cur ? cur.o.slice() : P.values.map((a) => a[0]);
    const S = { size: null, view: 'ring', gi: 0, gkey: null };
    const find = (o) => V.find((v) => v.o.every((x, i) => x === o[i])) || null;
    const variantWith = (over) => { const o = sel.slice(); Object.keys(over).forEach((i) => { o[i] = over[i]; }); return find(o); };
    const priceWith = (over) => { const v = variantWith(over); return v ? v.price : null; };
    const caratVal = (n) => { const c = carats.find((x) => x.n === n); return c ? c.v : null; };
    const curCarat = () => (iC >= 0 ? (carats.find((x) => x.v === sel[iC]) || {}).n : null);
    const curMetal = () => (iM >= 0 ? metals.find((x) => x.v === sel[iM]) : null);
    function metalValue(c, k) {
      const hit = metals.find((x) => x.c === c && x.k === k) || metals.find((x) => x.c === c);
      return hit ? hit.v : null;
    }
    // defaults on a clean visit (no ?variant=): preselected carat + metal + first quality
    if (!J.urlVariant) {
      const dc = caratVal(parseFloat(ST.defaultCarat)); if (iC >= 0 && dc) sel[iC] = dc;
      if (iM >= 0 && ST.defaultMetal) { const dm = metals.find((x) => x.v.toLowerCase() === String(ST.defaultMetal).toLowerCase()); if (dm) sel[iM] = dm.v; }
      if (iQ >= 0) sel[iQ] = qualities[0];
    }
    // carried over from a sibling shape (?er_ct=2&er_m=14KY&er_q=0&er_v=hand)
    if (qs.get('er_ct') && iC >= 0) { const v = caratVal(parseFloat(qs.get('er_ct'))); if (v) sel[iC] = v; }
    if (qs.get('er_m') && iM >= 0) { const m = /^(\d+K)([YWR])$/.exec(qs.get('er_m')); if (m) { const v = metalValue(m[2], m[1]); if (v) sel[iM] = v; } }
    if (qs.get('er_q') && iQ >= 0 && qualities[+qs.get('er_q')]) sel[iQ] = qualities[+qs.get('er_q')];
    if (!find(sel) && cur) cur.o.forEach((x, i) => { sel[i] = x; });

    /* ---------- labels ---------- */
    const ctTxt = (n) => (n == null ? '' : String(n));
    const ctShort = (n) => `${n} ct${shape ? ' ' + shapeName.toLowerCase() : ''}`;
    const metalLabel = () => { const m = curMetal(); return m ? `${m.k ? m.k + ' ' : ''}${COLOR_LABEL[m.c].toLowerCase()}` : ''; };
    function mmText(v) {
      if (v && v.mm) return `about ${v.mm}`;
      const n = curCarat(), m = shape && G.MM[shape] && G.MM[shape][n];
      if (!m) return '';
      return m[0] === m[1] ? `about ${m[0].toFixed(1)} mm across` : `about ${m[0].toFixed(1)} × ${m[1].toFixed(1)} mm`;
    }
    function cfgText(long) {
      const parts = [];
      if (iC >= 0) parts.push(`${ctTxt(curCarat())} ct${shape ? ' ' + shapeName.toLowerCase() : ''}`);
      if (iM >= 0) parts.push(metalLabel());
      sel.forEach((v, i) => { if (i !== iC && i !== iM && i !== iQ) parts.push(v); });
      if (long && iQ >= 0) parts.push(sel[iQ]);
      return parts.join(', ');
    }
    const shipDate = () => (P.mto && P.leadDays ? G.shipBy(+P.leadDays) : '');
    const productLink = () => `${location.origin}${P.url}${cur ? '?variant=' + cur.id : ''}`;
    const smsHref = () => `sms:${ST.tel}?&body=${encodeURIComponent(`Hi GOLDZENN, I have a question about the ${P.design}: ${cfgText(true)}${S.size && S.size !== 'helre' ? ', size ' + S.size : ''}. ${productLink()}`)}`;

    /* ---------- analytics (dataLayer + gtag with send_to; see GA4 memo) ---------- */
    function track(name, extra) {
      const item = cur ? { item_id: cur.sku || String(cur.id), item_name: P.title, item_variant: cur.title, item_brand: 'GOLDZENN', item_category: 'Engagement Ring', price: cur.price / 100, quantity: 1 } : null;
      const base = Object.assign({ gz_section: 'engagement_pdp', gz_pdp_arm: ST.arm || 'B', currency: J.currency || 'USD', value: cur ? cur.price / 100 : 0 }, extra || {});
      const ecom = name === 'view_item' || name === 'add_to_cart';
      try {
        window.dataLayer = window.dataLayer || [];
        if (ecom) window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(Object.assign({ event: name }, base, ecom ? { ecommerce: { currency: base.currency, value: base.value, items: item ? [item] : [] } } : {}));
      } catch (e) { /* never break the page */ }
      try {
        if (!ST.ga4) return;
        let g = name;
        if (ecom) { if (ST.ga4Ecom === 'off') return; if (ST.ga4Ecom !== 'standard') g = 'gz_er_' + name; }
        // gtag.js may not be loaded yet at first paint: queue the command the standard way (gtag.js replays dataLayer commands)
        const gt = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
        gt('event', g, Object.assign({}, base, { items: item ? [item] : [], send_to: ST.ga4 }));
      } catch (e) { /* never break the page */ }
    }
    const opt = (name, value) => track('select_option', { option_name: name, option_value: String(value) });

    /* ---------- static controls ---------- */
    root.style.setProperty('--hx', (ST.handFx ?? 49) + '%');
    root.style.setProperty('--hy', (ST.handFy ?? 52) + '%');
    root.style.setProperty('--hz', (ST.handZoom || 100) / 100);
    root.style.setProperty('--cz', (ST.cmpZoom || 170) / 100);

    // metal dots + karat switch
    if (colors.length) {
      $('[data-b-metal]').hidden = false;
      const SHORT = { Y: 'Yellow', W: 'White', R: 'Rose' };
      $('[data-b-dots]').innerHTML = colors.map((c) => `<button type="button" class="gzb-gold" role="radio" data-c="${c}" aria-checked="false" aria-label="${COLOR_LABEL[c]}"><i class="gzb-gold__dot gzb-gold__dot--${c}"></i><span>${SHORT[c]}</span></button>`).join('');
      if (karats.length > 1) {
        $('[data-b-karat]').hidden = false;
        $('[data-b-karat]').innerHTML = karats.map((k) => `<button type="button" role="radio" data-k="${k}" aria-checked="false" aria-label="${k.replace('K', ' karat')}">${k}</button>`).join('');
      }
    }
    // carat slider
    const pct = (i) => (carats.length > 1 ? (i / (carats.length - 1)) * 100 : 0);
    if (carats.length > 1) {
      $('[data-b-carat]').hidden = false;
      const r = $('[data-b-range]'); r.max = String(carats.length - 1);
      $('[data-b-tickmarks]').innerHTML = carats.map((_, i) => `<span class="gzb-tick" style="left:${pct(i)}%"></span>`).join('');
      $('[data-b-ticks]').innerHTML = carats.map((c, i) => `<button type="button" tabindex="-1" data-ct="${c.n}" style="left:${pct(i)}%">${c.n}</button>`).join('');
    }
    // shapes = sibling products
    const sibs = [];
    (P.siblings || []).forEach((s) => {
      const key = G.shapeKey(s.shape) || G.shapeKey(s.title);
      const id = key || s.url;
      if (!s.url || sibs.some((x) => x.id === id)) return;
      sibs.push({ id, key, url: s.url, current: !!s.current, label: key ? G.SHAPES[key].label : (s.shape || s.title) });
    });
    if (sibs.length && !sibs.some((s) => s.current)) {
      // custom.shape_siblings may omit the product itself: insert it in the usual shape order
      const me = { id: shape || P.url, key: shape, url: P.url, current: true, label: shapeName || P.design };
      const rank = (k) => { const i = G.SHAPE_ORDER.indexOf(k); return i < 0 ? 99 : i; };
      const at = sibs.findIndex((s) => rank(s.key) > rank(shape));
      sibs.splice(at < 0 ? sibs.length : at, 0, me);
    }
    { const rank = (k) => { const i = G.SHAPE_ORDER.indexOf(k); return i < 0 ? 99 : i; }; sibs.sort((a, b) => rank(a.key) - rank(b.key)); }   // same order as the collection swatches
    const sibOK = sibs.length > 1;
    if (sibOK) {
      $('[data-b-shape-field]').hidden = false;
      const box = $('[data-b-shapes]'); box.setAttribute('role', 'list');
      box.innerHTML = sibs.map((s, i) => `<a class="gzb-shape" role="listitem" href="${esc(s.url)}" data-sib="${i}"${s.current ? ' aria-current="page"' : ''}>${s.key ? G.shapeIcon(s.key) : ''}<span>${esc(s.label)}</span></a>`).join('');
    }
    // ring sizes (line-item property)
    const SIZES = [];
    $('[data-b-size-blk]').hidden = !ST.needSize;
    if (ST.needSize) {
      const step = ST.sizeQuarter ? 0.25 : 0.5;
      for (let s = +ST.sizeMin || 3; s <= (+ST.sizeMax || 10) + 1e-9; s += step) SIZES.push(+s.toFixed(2));
      const html = SIZES.map((s) => `<button type="button" role="radio" data-size="${s}" aria-checked="false"${s >= 6 && s <= 7 ? ' class="is-pop"' : ''}>${s}</button>`).join('') ;   // UPDATE 23: 6-7 marked as most common   // UPDATE 11: no 'help me find it' option; the size guide + text-a-jeweler cover it
      $$('[data-b-sizes]').forEach((b) => { b.innerHTML = html; });
    }

    /* ---------- on-hand images + compare ---------- */
    const hands = (P.onHand || []).map((h) => {
      const file = decodeURIComponent(String(h.src).split('?')[0].split('/').pop() || '');
      const t = `${h.alt || ''} ${file}`;
      const m = /(\d+(?:\.\d+)?)\s*ct/i.exec(t);
      const c = /yellow/i.test(t) ? 'Y' : /white/i.test(t) ? 'W' : /rose/i.test(t) ? 'R' : ((/__([YWR])__/.exec(t) || [])[1] || null);
      return Object.assign({}, h, { ct: m ? parseFloat(m[1]) : null, c });
    });
    function pickHand(n, c) {   // product-level fallback (custom.on_hand_images; carat + colour parsed from alt/filename)
      if (!hands.length) return null;
      const known = hands.filter((h) => h.ct != null);
      if (!known.length || n == null) return hands.find((h) => h.c === c) || hands[0];
      let rung = known.filter((h) => h.ct === n);
      if (!rung.length) {
        const lower = known.filter((h) => h.ct < n).sort((a, b) => b.ct - a.ct);
        const ref = lower.length ? lower[0].ct : known.slice().sort((a, b) => a.ct - b.ct)[0].ct;
        rung = known.filter((h) => h.ct === ref);
      }
      return rung.find((h) => h.c === c) || rung.find((h) => h.c === 'Y') || rung[0];
    }
    /* UPDATE 7: per-variant on-hand (variant custom.on_hand). One image per carat × colour; karat/quality share it. */
    const OHM = J.onHandMap || {};
    const vCt = (v) => (iC >= 0 ? G.caratNum(v.o[iC]) : null), vC = (v) => (iM >= 0 ? G.colourOf(v.o[iM]) : null);
    const ohVars = V.filter((v) => v.oh && OHM[v.oh]);
    const perVariant = ohVars.length > 0;
    const asHand = (v) => (v ? Object.assign({ ct: vCt(v), c: vC(v) }, OHM[v.oh]) : null);
    // exact carat, preferring the selected colour, then yellow, then any colour (null if this carat has no on-hand image)
    function exactHand(n, c) {
      if (!perVariant) { const r = hands.filter((h) => h.ct === n); return r.find((h) => h.c === c) || r.find((h) => h.c === 'Y') || r[0] || null; }
      const r = ohVars.filter((v) => vCt(v) === n);
      return asHand(r.find((v) => vC(v) === c) || r.find((v) => vC(v) === 'Y') || r[0]);
    }
    // what "On the hand" shows: the selected variant's own image, else the nearest carat that has one (note says so)
    function handFor(n, c) {
      if (!perVariant) return pickHand(n, c);
      if (cur && cur.oh && OHM[cur.oh] && vCt(cur) === n) return asHand(cur);
      const ex = exactHand(n, c); if (ex && (ex.c === c || !c)) return ex;
      const pool = ohVars.filter((v) => vC(v) === c).length ? ohVars.filter((v) => vC(v) === c) : ohVars;
      const best = pool.slice().sort((a, b) => Math.abs(vCt(a) - n) - Math.abs(vCt(b) - n) || vCt(a) - vCt(b))[0];
      return ex && Math.abs(vCt(best) - n) > 0 ? ex : asHand(best);
    }
    // Compare = 3 tiles from THIS product: the selected carat and its neighbours (widest even spread available)
    function cmpList() {
      if (iC < 0) return [];
      const m = curMetal(), c = m ? m.c : null, i = carats.findIndex((x) => x.v === sel[iC]);
      const ok = (k) => carats[k] && priceWith({ [iC]: carats[k].v }) != null && !!exactHand(carats[k].n, c);
      let ks = null;
      if (ok(i)) {
        if (ok(i - 2) && ok(i + 2)) ks = [i - 2, i, i + 2];
        else if (ok(i - 1) && ok(i + 1)) ks = [i - 1, i, i + 1];
      }
      if (!ks) ks = carats.map((_, k) => k).filter(ok).sort((a, b) => Math.abs(a - i) - Math.abs(b - i) || a - b).slice(0, 3).sort((a, b) => a - b);
      return ks.map((k) => carats[k].n);
    }
    const ohCarats = new Set(perVariant ? ohVars.map(vCt) : hands.filter((h) => h.ct != null).map((h) => h.ct));
    const modes = ['ring'];
    if (perVariant || hands.length) modes.push('hand');
    if ((iC >= 0 && [...ohCarats].filter((n) => caratVal(n) != null).length >= 2) || P.chart) modes.push('compare');
    const MODE_LABEL = { ring: 'Ring', hand: 'On the hand', compare: 'Compare' };
    if (modes.length > 1) {
      const vb = $('[data-b-views]'); vb.hidden = false;
      vb.innerHTML = `<span class="gzb-views__pill" aria-hidden="true" style="width:calc((100% - 6px) / ${modes.length})"></span>` +
        modes.map((m) => `<button type="button" data-view="${m}" aria-pressed="${m === 'ring'}">${MODE_LABEL[m]}</button>`).join('');
    }
    const mmShort = (n) => { const m = shape && G.MM[shape] && G.MM[shape][n]; return m ? (m[0] === m[1] ? `≈ ${m[0].toFixed(1)} mm` : `≈ ${m[0].toFixed(1)}×${m[1].toFixed(1)} mm`) : ''; };   // ≈ = approximate (short enough for a 110 px tile)

    function showHand(animateIn) {
      const m = curMetal(), n = curCarat(), h = handFor(n, m ? m.c : null), img = $('[data-b-hand]');
      if (!h) return;
      if (img.dataset.base !== h.src) {
        img.dataset.base = h.src;
        if (h.w && h.h) { img.width = h.w; img.height = h.h; }
        if (!reduce && !animateIn && img.classList.contains('is-in')) { img.classList.add('is-swap'); setTimeout(() => img.classList.remove('is-swap'), 260); }
        G.setImg(img, h.src, h.w, SZ.stage);
      }
      img.alt = `Digital size preview on the hand${h.ct ? ': ' + h.ct + ' carat' : ''}${shape ? ' ' + shapeName.toLowerCase() : ''}`;
      const notes = [];
      if (h.ct != null && n != null && h.ct !== n) {
        const a = shape && G.MM[shape] && G.MM[shape][n], b = shape && G.MM[shape] && G.MM[shape][h.ct];
        const pc = a && b ? Math.round((a[0] / b[0] - 1) * 100) : null;
        notes.push(pc ? `Shown at ${h.ct} ct. Your ${n} ct is about ${Math.abs(pc)}% ${pc > 0 ? 'longer' : 'shorter'}.` : `Shown at ${h.ct} ct.`);
      }
      if (m && h.c && h.c !== m.c) notes.push(`Shown in ${COLOR_LABEL[h.c].toLowerCase()}.`);
      if (ST.handNote) notes.push(ST.handNote);
      $('[data-b-hand-note]').textContent = notes.join(' ');
      if (animateIn) { img.classList.remove('is-in'); void img.offsetWidth; requestAnimationFrame(() => requestAnimationFrame(() => img.classList.add('is-in'))); }
      else img.classList.add('is-in');
    }
    function showCompare() {
      const m = curMetal(), c = m ? m.c : null, list = cmpList(), box = $('[data-b-cmp]');
      if (list.length >= 2) {
        box.classList.remove('gzb-cmp--chart'); box.style.setProperty('--n', list.length);
        // ONE crop box for all tiles (same centre + size) so relative stone sizes stay true; no per-tile zoom.
        // Size: base share of the frame (setting, default 60%) grown for bigger stones than 3 ct; centre = stone position settings.
        const L = (n) => { const t = shape && G.MM[shape]; const m = t && (t[n] || t[4]); return m ? m[0] : null; };
        const big = Math.max(...list), grow = L(big) && L(3) ? Math.max(1, L(big) / L(3)) : 1;
        const cf = Math.min(1, ((ST.cmpCrop || 60) / 100) * grow);
        const cx = Math.min(Math.max((ST.handFx ?? 49) / 100, cf / 2), 1 - cf / 2), cy = Math.min(Math.max((ST.handFy ?? 52) / 100, cf / 2), 1 - cf / 2);
        box.style.setProperty('--cf', cf.toFixed(3)); box.style.setProperty('--cl', ((0.5 - cx / cf) * 100).toFixed(2) + '%'); box.style.setProperty('--ct', ((0.5 - cy / cf) * 100).toFixed(2) + '%');
        $('[data-b-cmp-head]').textContent = 'Same ring, three center sizes';
        let other = null;
        box.innerHTML = list.map((n) => {
          const h = exactHand(n, c), p = priceWith({ [iC]: caratVal(n) }); if (c && h.c && h.c !== c) other = h.c;
          return `<button type="button" class="gzb-cmp__tile" data-ct="${n}" aria-pressed="${curCarat() === n}" aria-label="${n} carat, ${G.money(p)}">
            <span class="gzb-cmp__lit"><img src="${esc(G.sized(h.src, 400))}" srcset="${esc(G.srcset(h.src, h.w))}" sizes="${SZ.tile}" alt="${n} carat${shape ? ' ' + shapeName.toLowerCase() : ''} on the hand, digital size preview" loading="lazy" decoding="async"${h.w ? ` width="${h.w}" height="${h.h}"` : ''}></span><span class="gzb-cmp__ct">${n} ct</span><span class="gzb-cmp__mm">${mmShort(n)}</span><span class="gzb-cmp__p">${G.money(p)}</span></button>`;
        }).join('');
        $('[data-b-cmp-note]').textContent = [ST.handNote, 'Tap a size to choose it.', other ? `Some sizes shown in ${COLOR_LABEL[other].toLowerCase()}.` : ''].filter(Boolean).join(' ');
      } else if (P.chart) {   // fallback only when no per-carat on-hand exists
        box.classList.add('gzb-cmp--chart'); box.style.setProperty('--n', 1);
        $('[data-b-cmp-head]').textContent = 'Carat sizes on the hand';
        box.innerHTML = `<img class="gzb-chart" src="${esc(G.sized(P.chart.src, 800))}" srcset="${esc(G.srcset(P.chart.src, P.chart.w))}" sizes="${SZ.chart}" alt="${esc(P.chart.alt || 'Carat sizes on the hand')}" loading="lazy" decoding="async"${P.chart.w ? ` width="${P.chart.w}" height="${P.chart.h}"` : ''}>`;
        $('[data-b-cmp-note]').textContent = ST.handNote || '';
      }
    }
    function setView(v, fromUser) {
      if (!modes.includes(v)) v = 'ring';
      S.view = v; $('[data-b-vit]').dataset.view = v;
      $$('[data-b-views] button').forEach((b, i) => {
        const on = b.dataset.view === v; b.setAttribute('aria-pressed', String(on));
        if (on) $('.gzb-views__pill').style.transform = `translateX(${i * 100}%)`;
      });
      $$('[data-b-layer]').forEach((l) => l.classList.toggle('is-on', l.dataset.bLayer === v));
      if (v === 'hand') { showHand(fromUser && !reduce); preload(); }
      if (v === 'compare') showCompare();
      if (v !== 'ring') { if (S.tt) { ttLeave(); showRing(); opt('view_360', 'off'); } else if (video) try { video.pause(); } catch (e) {} } else if (S.tt) showRing();   // UPDATE 18: another view leaves the 360; Ring then shows the photo the shopper left
      if (fromUser) opt('view', v);
    }

    /* ---------- the ring (crossfade between two stacked images; optional video) ---------- */
    const rings = $$('[data-b-ring]'), video = $('[data-b-video]');
    const SZ = Object.assign({ ring: '(min-width: 1024px) 490px, (min-width: 440px) 361px, 82vw', stage: '(min-width: 1024px) 600px, (min-width: 440px) 440px, 100vw', tile: '(min-width: 1024px) 300px, 200px', chart: '(min-width: 1024px) 600px, 100vw' }, ST.sizes || {});
    const baseKey = (u) => String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '').replace(/^https?:/, '');
    let front = rings.find((r) => r.classList.contains('is-on')) || rings[0], back = rings.find((r) => r !== front), want = baseKey(front.getAttribute('src'));
    // images only; video comes only from the 360° button below (supplier turntables), never from the gallery
    function gallery() { return ((cur && J.galleries[cur.g]) || []).filter((x) => x.t !== 'video'); }

    /* ---------- 360° turntable (UPDATE 16, 2026-10-22: supplier CGI turntables, owner-approved; AI 360s stay rejected) ----------
       P.turntables = product custom.turntable_videos (one MP4 per gold colour). Liquid cannot read a file name, so the colour is
       read from the video's alt text ("yellow" / "white" / "rose", or "-yellow-360") and, as a fallback, from its URL.
       The 360° button shows only when the SELECTED colour has a video. Legacy custom.supplier_turntable_video (P.turntable,
       one video for every colour) is used only when no colour-tagged turntable exists. Nothing downloads until the tap
       (src set on tap; preload none). Reduced motion: never autoplays; the play button starts it. */
    const COLOUR_WORD = { yellow: 'Y', white: 'W', rose: 'R' };
    const colourIn = (t) => { const s = String(t || '').toLowerCase(); const m = /-(yellow|white|rose)-360/.exec(s) || /\b(yellow|white|rose)\b/.exec(s); return m ? COLOUR_WORD[m[1]] : null; };
    const TT = {};
    (P.turntables || []).forEach((t) => {
      if (!t || !t.src) return;
      const c = colourIn(t.alt) || colourIn(decodeURIComponent(String(t.src).split('?')[0].split('/').pop() || ''));
      if (c && !TT[c]) TT[c] = Object.assign({ t: 'video' }, t, { c });
    });
    const ttByColour = Object.keys(TT).length > 0;
    if ((P.turntables || []).length && !ttByColour) console.warn('gz-er-pdp: custom.turntable_videos has no gold colour in its alt text; 360° hidden');
    // UPDATE 18: the selected gold has no (working) video -> the white one, else yellow, else rose; the caption names the gold shown
    function ttCur() {
      const ok = (t) => (t && t.src && !t.bad ? t : null);
      if (!ttByColour) return ok(P.turntable);
      const m = curMetal(); if (m && ok(TT[m.c])) return TT[m.c];
      return ['W', 'Y', 'R'].map((c) => ok(TT[c])).find(Boolean) || null;
    }
    S.tt = qs.get('er_tt') === '1'; S.ttPaused = reduce;
    const ringLayer = $('[data-b-layer="ring"]');
    const ICON_360 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><ellipse cx="12" cy="12" rx="9" ry="4.2"/><path d="m15.5 18.4 2.3-2.1-2.6-1.7"/></svg>';
    const ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="7" y="6" width="3.4" height="12" rx="1"/><rect x="13.6" y="6" width="3.4" height="12" rx="1"/></svg>';
    const ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
    const ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 6.5 9 12l5.5 5.5"/></svg>';
    const ttBar = document.createElement('div'); ttBar.className = 'gzb-360bar';
    ttBar.innerHTML = `<button type="button" class="gzb-360play" data-b-360-play hidden></button><button type="button" class="gzb-360" data-b-360 aria-label="360° view" hidden>${ICON_360}<span>360°</span></button>`;
    const photoNote = document.createElement('p'); photoNote.className = 'gzb-note gzb-note--photo'; photoNote.setAttribute('data-b-photo-note', ''); photoNote.hidden = true;
    if (ringLayer && video) ringLayer.append(ttBar, photoNote);
    const ttBtn = $('[data-b-360]', ttBar), ttPlay = $('[data-b-360-play]', ttBar);
    /* UPDATE 18 (owner): leaving the 360 goes back to the photo the shopper had before it: the same angle (front / angle / side…,
       matched by file name, else the same gallery position) of the CURRENT selection, so carat / gold / quality picked during
       the 360 still apply. Exits: the button (reads "Photos" while the 360 is on), a swipe, On the hand / Compare, a broken file. */
    const angleOf = (x) => { const f = decodeURIComponent(String((x && x.src) || '').split('?')[0].split('/').pop() || '').toLowerCase(); const m = /(?:^|[-_.])(front|angled?|side|top|profile|back|tilt|upright|flat|hand)(?=[-_.]|$)/.exec(f); return m ? m[1] : null; };
    function ttEnter() { const gal = gallery(); S.ttFrom = { gi: S.gi, angle: angleOf(gal[S.gi]) }; S.tt = true; }
    function ttLeave() {
      S.tt = false; const f = S.ttFrom; S.ttFrom = null; if (!f) return;
      const gal = gallery(); let gi = Math.min(f.gi, Math.max(0, gal.length - 1));
      if (f.angle) { const hits = gal.map((x, i) => (angleOf(x) === f.angle ? i : -1)).filter((i) => i >= 0); if (hits.includes(f.gi)) gi = f.gi; else if (hits.length) gi = hits[0]; }
      S.gi = gi;
    }
    function syncTT() {
      const t = video ? ttCur() : null;
      if (!t && S.tt) ttLeave();
      ttBtn.hidden = !t;
      if (ttBtn.dataset.on !== String(S.tt)) {   // while the 360 is on the button is the way out: "‹ Photos"
        ttBtn.dataset.on = String(S.tt); ttBtn.classList.toggle('is-on', S.tt);
        ttBtn.innerHTML = S.tt ? `${ICON_BACK}<span>Photos</span>` : `${ICON_360}<span>360°</span>`;
        ttBtn.setAttribute('aria-label', S.tt ? 'Back to photos' : '360° view');
      }
      ttPlay.hidden = !S.tt;
      ttPlay.innerHTML = S.ttPaused ? ICON_PLAY : ICON_PAUSE;
      ttPlay.setAttribute('aria-label', S.ttPaused ? 'Play the 360° view' : 'Pause the 360° view');
    }
    function showVideo(t, item) {
      rings.forEach((r) => r.classList.remove('is-on'));
      const poster = item ? G.sized(item.src, G.pickedWidth(front) || 800) : t.poster;   // poster = the current hero photo
      if (poster) video.poster = poster;
      video.muted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('aria-label', t.alt || `${P.design}${shape ? ' ' + shapeName.toLowerCase() : ''}, 360° view${iM >= 0 ? ', ' + metalLabel() : ''}`);
      if (video.getAttribute('src') !== t.src) video.src = t.src;
      video.hidden = false; video.classList.add('is-on');
      if (S.ttPaused) { try { video.pause(); } catch (e) {} } else video.play().catch(() => {});
      want = t.src;
    }
    function hideVideo() { if (!video) return; video.classList.remove('is-on'); video.hidden = true; try { video.pause(); } catch (e) {} }
    if (video) video.addEventListener('error', () => {   // a broken file: drop that colour's 360 and go back to the photo
      const t = ttCur(); if (t && video.getAttribute('src') === t.src) { t.bad = true; ttLeave(); showRing(); }
    });
    ttBtn.addEventListener('click', () => { if (S.tt) ttLeave(); else { ttEnter(); S.ttPaused = reduce; } showRing(); opt('view_360', S.tt ? 'on' : 'off'); });
    ttPlay.addEventListener('click', () => { S.ttPaused = !S.ttPaused; if (S.ttPaused) video.pause(); else video.play().catch(() => {}); syncTT(); opt('view_360', S.ttPaused ? 'pause' : 'play'); });

    /* Photo-size caption (UPDATE 16): product custom.photo_center_ct = the carat the supplier photos show. When the selected
       carat differs by more than 0.25 ct AND the variant's gallery has no "__<carat>ct__" image, say so under the ring. */
    const photoCt = P.photoCt == null || P.photoCt === '' ? null : parseFloat(P.photoCt);
    const ctFmt = (x) => String(+(+x).toFixed(2));
    function photoNoteText() {
      if (photoCt == null || isNaN(photoCt) || iC < 0) return '';
      const n = curCarat(); if (n == null || Math.abs(n - photoCt) <= 0.25 + 1e-9) return '';
      const g = (cur && J.galleries[cur.g]) || [];
      const exact = g.some((x) => { const f = decodeURIComponent(String(x.src || '').split('?')[0].split('/').pop() || ''); const re = /__(\d+(?:\.\d+)?)ct__/gi; let mm; while ((mm = re.exec(f))) { if (Math.abs(parseFloat(mm[1]) - n) < 1e-6) return true; } return false; });
      return exact ? '' : `<span>Photos show about ${ctFmt(photoCt)} ct.</span> <span>Your selected size: ${ctFmt(n)} ct.</span>`;
    }
    /* UPDATE 18: borrowed turntable caption. custom.turntable_source_shape (e.g. "Emerald") = the video shows another center shape
       than this listing; and when the selected gold has no video, the caption names the gold shown. Blank metafield = no shape part. */
    const ttShape = String(P.ttShape || '').trim().toLowerCase();
    const ttShapeOther = !!ttShape && ttShape !== shapeName.toLowerCase() && ttShape !== String(P.shape || '').trim().toLowerCase();
    function ttNoteText(t) {
      const parts = [], m = curMetal();
      if (ttShapeOther) parts.push(`with ${/^[aeiou]/.test(ttShape) ? 'an' : 'a'} ${ttShape} center`);
      if (t && t.c && m && m.c && t.c !== m.c) parts.push(`in ${COLOR_LABEL[t.c].toLowerCase()}`);
      return parts.length ? `360° view shown ${parts.join(' ')}.` : '';
    }
    function ringAlt(item) {
      if (item && item.alt) return item.alt;
      return `${P.design}${iC >= 0 ? ', ' + ctTxt(curCarat()) + ' ct' : ''}${shape ? ' ' + shapeName.toLowerCase() : ''}${stone ? ' ' + stone + ' diamond' : ''}${iM >= 0 ? ', ' + metalLabel() : ''}`;
    }
    function showRing(dir) {
      syncTT();   // first: leaving the 360 here may restore the photo position (S.gi)
      const gal = gallery(), item = gal[S.gi] || gal[0];
      const t = S.tt ? ttCur() : null, ttn = t ? ttNoteText(t) : '';
      const note = (ttn ? `<span class="gzb-note__tt" data-b-tt-note>${esc(ttn)}</span>` : '') + photoNoteText(); photoNote.innerHTML = note; photoNote.hidden = !note;
      if (t) { showVideo(t, item); syncTT(); return; }
      hideVideo();
      if (!item) return;
      const src = baseKey(item.src); if (src === want && front.classList.contains('is-on')) { front.alt = ringAlt(item); return; }
      want = src;
      const pre = new Image(); G.setImg(pre, item.src, item.w, SZ.ring);   // same srcset + sizes as the visible img -> same candidate, one download
      const done = () => {
        if (want !== src) return;
        const stack = $('[data-b-stack]');
        back.hidden = false; G.setImg(back, item.src, item.w, SZ.ring); back.alt = ringAlt(item);
        if (item.w && item.h) { back.width = item.w; back.height = item.h; }
        if (!reduce) {
          stack.classList.remove('slide-l', 'slide-r', 'pulse');
          if (dir) stack.classList.add(dir > 0 ? 'slide-r' : 'slide-l');
          void stack.offsetWidth; stack.classList.remove('slide-l', 'slide-r');
          if (!dir) stack.classList.add('pulse');
        }
        back.classList.add('is-on'); front.classList.remove('is-on'); [front, back] = [back, front];
      };
      (pre.decode ? pre.decode() : Promise.resolve()).then(done, done);
    }
    /* Prefetch ONLY the neighbours of the current choice (carat -1/+1 at this metal, the other gold colours at this carat;
       on the hand view, the -1/+1 carat hand images) at the width the browser already picked for the visible image.
       Nothing is prefetched until the shopper touches a control, so first load = the hero only. */
    let armed = false; const fetched = new Set();
    function warm(u, w) { if (!u) return; const url = w ? G.sized(u, w) : u; if (fetched.has(url)) return; fetched.add(url); const i = new Image(); i.decoding = 'async'; i.src = url; }
    function preload() {
      if (!armed) return;
      (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(() => {
        const wRing = G.pickedWidth(front) || G.pickedWidth(back), heroOf = (v) => { const g = v && J.galleries[v.g]; return g && g[0] && g[0].t === 'img' ? g[0].src : null; };
        if (iC >= 0) { const i = carats.findIndex((c) => c.v === sel[iC]); [i - 1, i + 1].forEach((k) => { if (carats[k]) warm(heroOf(variantWith({ [iC]: carats[k].v })), wRing); }); }
        const m = curMetal(); if (m) colors.filter((c) => c !== m.c).forEach((c) => { const v = metalValue(c, m.k); if (v) warm(heroOf(variantWith({ [iM]: v })), wRing); });
        if ((S.view === 'hand' || S.view === 'compare') && modes.includes('hand') && iC >= 0) {
          const wHand = G.pickedWidth($('[data-b-hand]')), i = carats.findIndex((c) => c.v === sel[iC]);
          [i - 1, i + 1].forEach((k) => { if (carats[k]) { const h = handFor(carats[k].n, m ? m.c : null); if (h) warm(h.src, wHand); } });
          if (m) colors.filter((x) => x !== m.c).forEach((x) => { const h = exactHand(carats[i].n, x); if (h && h.c === x) warm(h.src, wHand); });
        }
      });
    }
    const arm = () => { if (!armed) { armed = true; preload(); } };
    ['pointerdown', 'keydown', 'focusin'].forEach((t) => root.querySelector('.gzb-stage').addEventListener(t, arm, { passive: true }));

    /* ---------- price counter ---------- */
    let shown = null, raf;
    function setPrice(p) {
      const els = $$('.js-count'), put = (t) => els.forEach((e) => { e.textContent = t; });
      if (p == null) { put('Unavailable'); shown = null; return; }
      if (shown == null || reduce) { put(G.money(p)); shown = p; return; }
      if (p === shown) return;
      const d = p - shown;
      $$('.js-delta').forEach((el) => { el.textContent = (d > 0 ? '+' : '−') + G.money(Math.abs(d)); el.classList.remove('go'); void el.offsetWidth; el.classList.add('go'); });
      const from = shown, t0 = performance.now(), dur = 520; shown = p;
      cancelAnimationFrame(raf);
      const step = (t) => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); put(G.money(Math.round((from + (p - from) * e) / 500) * 500)); if (k < 1) raf = requestAnimationFrame(step); else put(G.money(p)); };
      raf = requestAnimationFrame(step);
    }

    /* ---------- included / details (metafield-gated) ---------- */
    function included() {
      const inc = [], side = [], ship = shipDate();
      if (P.certificate) {
        const no = cur && cur.igi ? ` Report no. ${esc(cur.igi)}.` : '';
        inc.push(`<li>${svg('shield')}<span><b>${esc(P.certificate)} report for the center diamond.</b>${no}</span></li>`);
        side.push(`<li><b>${esc(P.certificate)} report</b> for the center diamond</li>`);
      }
      if (ST.appraisal) {
        const parts = String(ST.appraisal).split(/\s+[—–-]\s+/);
        const html = parts.length > 1 ? `<b>${esc(parts[0])}</b> — ${esc(parts.slice(1).join(' — '))}` : `<b>${esc(parts[0])}</b>`;
        inc.push(`<li>${svg('doc')}<span>${html}</span></li>`); side.push(`<li>${html}</li>`);
      }
      if (P.mto && (ship || P.leadText)) {
        inc.push(`<li>${svg('clock')}<span><b>Made to order.</b> ${ship ? `Order today and it ships by ${esc(ship)}${P.leadText ? ' (' + esc(P.leadText) + ')' : ''}.` : esc(P.leadText) + '.'}</span></li>`);
      }
      inc.push(`<li>${svg('ret')}<span><b>30-day returns</b> with a free return label (U.S.). <a href="${esc(ST.policyUrl)}">See our return policy</a>.</span></li>`);
      side.push(`<li>30-day returns · free return label · <a href="${esc(ST.policyUrl)}">policy</a></li>`);
      $('[data-b-inc]').innerHTML = inc.join(''); const incB = $('[data-b-inc-blk]'); if (incB.hidden) { incB.hidden = false; if (desk() && incB.tagName === 'DETAILS') incB.open = true; }   // UPDATE 23b: open on desktop (trust signals next to the price)
      $('[data-b-side-inc]').innerHTML = side.join('');
      $('[data-b-buy-ship]').textContent = P.mto ? (ship ? `Made to order. Ships by ${ship}.` : P.leadText ? `Made to order, ${P.leadText}.` : '') : '';
      $('[data-b-side-ship]').textContent = P.mto ? (ship ? `Made to order. Ships by ${ship}.` : P.leadText ? `Made to order, ${P.leadText}.` : '') : '';
    }
    function spec() {
      const rows = [];
      rows.push(['Design', `${P.design}${P.blurb ? '. ' + P.blurb : ''}`]);
      if (iC >= 0 || shape) {
        const bits = [];
        const kind = [stone ? stone.charAt(0).toUpperCase() + stone.slice(1) : '', shape ? (stone ? shapeName.toLowerCase() : shapeName) : ''].filter(Boolean).join(' ');
        if (kind) bits.push(kind);
        if (iC >= 0) bits.push(`${ctTxt(curCarat())} ct`);
        const mm = mmText(cur); if (mm) bits.push(mm + (P.certificate ? ` (exact size on the ${P.certificate} report)` : ''));
        rows.push(['Center diamond', bits.join(', ')]);
      }
      if (iQ >= 0) rows.push(['Quality', sel[iQ]]);
      if (iM >= 0) rows.push(['Metal', sel[iM]]);
      const d = P.details || {}, m = curMetal();
      const g = m && m.k === '18K' ? d.gold18 : d.gold14;
      if (g) rows.push(['Gold weight', `about ${g} g (size 7)`]);
      if (d.side) rows.push(['Side stones', `${d.side} ct total`]);
      if (d.band) rows.push(['Band width', `${d.band} mm`]);
      $('[data-b-spec]').innerHTML = rows.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('');
    }
    /* Quality in plain English: one line ("VS1 · F–G (our pick) · Change") that opens 3 tiers. Copy explains the grade
       letters and answers "will she see a difference?" honestly. Unknown grades fall back to the grade + standard definition. */
    function tierOf(q, i) {
      const t = String(q).toUpperCase(), d = /\bD\b/.test(t), vvs = /VVS/.test(t), fg = /F\s*[–-]\s*G/.test(t), vs = /\bVS1\b/.test(t);
      if (vs && fg) return { name: 'Our pick', what: 'Near-colorless (F–G) with tiny inclusions you need 10x magnification to find.', see: 'Will she see a difference? No. VS1 and VVS1 look the same to the eye.' };
      if (vvs && fg) return { name: 'Cleaner', what: 'The same near-colorless F–G color, with even fewer tiny inclusions under 10x magnification.', see: 'Will she see a difference? No. It looks the same as VS1 to the eye; the difference is on the grading report.' };
      if (vvs && d) return { name: 'Whitest', what: 'D is the top color grade: colorless, the whitest a diamond is graded. VVS1 clarity.', see: 'Will she see a difference? Maybe, side by side with an F–G stone in daylight. On its own, F–G already looks white.' };
      return { name: i === 0 ? 'Our pick' : q, what: G.qualityLine(q), see: '' };
    }
    function qualityCards() {
      const blk = $('[data-b-qual-blk]');
      if (iQ < 0) { blk.hidden = true; return; }
      blk.hidden = false;
      const qi = qualities.indexOf(sel[iQ]), tq = tierOf(sel[iQ], qi);
      $('[data-b-qline-v]').textContent = `${sel[iQ].replace(/\s+(?=[A-Z]–)/, ' · ')}${qi === 0 ? ' (our pick)' : ' (' + tq.name.toLowerCase() + ')'}`;
      $('[data-b-qual-intro]').textContent = `${stone ? `Every option is a ${stone} diamond. ` : ''}${ST.qualityIntro || ''}`.trim();
      const base = priceWith({ [iQ]: qualities[0] });
      $('[data-b-qual]').innerHTML = qualities.map((q, i) => {
        const p = priceWith({ [iQ]: q }), t = tierOf(q, i);
        const delta = p == null ? 'Unavailable' : base == null ? G.money(p) : p === base ? 'Base price' : (p > base ? '+' : '−') + G.money(Math.abs(p - base));
        return `<button type="button" role="radio" data-q="${esc(q)}" aria-checked="${sel[iQ] === q}"${p == null ? ' disabled' : ''}><span class="dot"></span><span><b>${esc(t.name)}</b> <span class="gzb-qual__g">${esc(q)}</span><small>${esc(t.what)}</small>${t.see ? `<small class="gzb-qual__see">${esc(t.see)}</small>` : ''}</span><em>${delta}</em></button>`;
      }).join('');
    }
    function otherOptions() {
      const idx = roles.map((r, i) => i).filter((i) => i !== iC && i !== iQ && i !== iM);
      const box = $('[data-b-other]');
      if (!idx.length) { box.hidden = true; return; }
      box.hidden = false;
      box.innerHTML = idx.map((i) => `<h3>${esc(P.options[i])}</h3><div class="gzb-chips" role="radiogroup" aria-label="${esc(P.options[i])}">` +
        P.values[i].map((v) => `<button type="button" role="radio" data-oi="${i}" data-ov="${esc(v)}" aria-checked="${sel[i] === v}"${priceWith({ [i]: v }) == null ? ' disabled' : ''}>${esc(v)}</button>`).join('') + '</div>').join('<div style="height:18px"></div>');
    }

    /* ---------- UPDATE 23: guided steps ---------- */
    const barCfg = () => cfgText(desk()) + (ST.needSize && S.size ? `, size ${S.size}` : '');
    const needPick = () => ST.needSize && !S.size;
    function steps() {
      const f = ['[data-b-shape-field]', '[data-b-carat]', '[data-b-metal]', '[data-b-qual-blk]', '[data-b-sizestep]'].map((q) => $(q)).filter((el) => el && !el.hidden);
      f.forEach((el, i) => {
        const done = el.matches('[data-b-sizestep]') ? !!S.size : true;
        el.dataset.done = String(done);
        const b = el.querySelector('[data-b-step]'); if (b) b.textContent = done ? '\u2713' : String(i + 1);
      });
    }
    function nudgeSize() {
      const el = $('[data-b-sizestep]'); if (!el || el.hidden) { addToBag(); return; }
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge');
      opt('size_nudge', 'cta');
      setTimeout(() => { const b = el.querySelector('[data-size="6.5"]') || el.querySelector('[data-size]'); if (b) b.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    }

    /* ---------- render ---------- */
    function render(o = {}) {
      cur = find(sel);
      const n = curCarat(), m = curMetal();
      setPrice(cur ? cur.price : null);
      $('[data-b-name]').textContent = P.design;
      $('[data-b-line]').textContent = [`${shapeName}${stone ? ' ' + stone + ' diamond' : ''}`.trim(), metalLabel()].filter(Boolean).join(', ');
      if (m) {
        $$('[data-b-dots] [data-c]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.c === m.c)));
        $$('[data-b-karat] [data-k]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.k === m.k)));
      }
      if (carats.length > 1) {
        const i = carats.findIndex((c) => c.n === n), r = $('[data-b-range]');
        r.value = String(i); r.setAttribute('aria-valuetext', `${n} carats${mmText(cur) ? ', ' + mmText(cur) : ''}`);
        $('[data-b-fill]').style.width = pct(i) + '%';
        $$('.gzb-tick').forEach((t, k) => t.classList.toggle('is-past', k <= i));
        $$('[data-b-ticks] button').forEach((b) => b.classList.toggle('is-on', +b.dataset.ct === n));
        $('[data-b-ct-num]').textContent = ctTxt(n);
        $('[data-b-ct-mm]').textContent = mmText(cur);
      }
      $('[data-b-bar-cfg]').textContent = barCfg();
      const ship = shipDate();
      const dSum = $('[data-b-drawer-sum]'); if (dSum) dSum.textContent = ship ? `Ships by ${ship}.` : '';   // UPDATE 23: size is step 5 now; drawer removed in 23b
      $('[data-b-sheet-sub]').textContent = `${P.design}, ${cfgText(true)}.${cur ? ' ' + G.money(cur.price) : ''}`;
      $$('[data-b-atc]').forEach((atc) => { atc.disabled = !cur || !cur.available; atc.textContent = !cur ? 'Unavailable' : !cur.available ? 'Sold out' : needPick() ? 'Choose size' : 'Add to bag'; });
      if (cur) { const key = cur.g; if (key !== S.gkey) { S.gkey = key; S.gi = 0; } }
      showRing(o.dir);
      if (S.view === 'hand') showHand(false);
      if (S.view === 'compare') showCompare();
      qualityCards(); otherOptions(); included(); spec();
      preload();
      $$('[data-b-sizes] [data-size]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.size === String(S.size))));
      const go = $('[data-b-sheet-go]');
      go.disabled = !S.size || !cur || !cur.available;
      go.textContent = !S.size ? 'Choose a size' : `Add to bag, size ${S.size}`;
      $$('[data-b-sms]').forEach((a) => { a.href = smsHref(); });
      steps();
      if (cur && !o.noUrl) { try { const u = new URL(location.href); u.searchParams.set('variant', cur.id); ['er_ct', 'er_m', 'er_q', 'er_v', 'er_tt'].forEach((k) => u.searchParams.delete(k)); history.replaceState(history.state, '', u); } catch (e) {} }
    }

    /* ---------- interactions ---------- */
    function goSibling(i, dir) {
      const s = sibs[i]; if (!s || s.current) return;
      opt('shape', s.label);
      const u = new URL(s.url, location.origin), here = new URLSearchParams(location.search);
      ['view', 'preview_theme_id'].forEach((k) => { if (here.get(k)) u.searchParams.set(k, here.get(k)); });
      const n = curCarat(), m = curMetal();
      if (n != null) u.searchParams.set('er_ct', n);
      if (m) u.searchParams.set('er_m', (m.k || '') + m.c);
      if (iQ >= 0) u.searchParams.set('er_q', qualities.indexOf(sel[iQ]));
      if (S.view !== 'ring') u.searchParams.set('er_v', S.view);
      if (S.tt) u.searchParams.set('er_tt', '1');   // keep the 360 on when the next shape has one for this gold
      if (!reduce) $('[data-b-stack]').classList.add(dir > 0 ? 'out-l' : 'out-r');
      setTimeout(() => { location.href = u.toString(); }, reduce ? 0 : 180);
    }
    if (sibOK) {
      $('[data-b-shapes]').addEventListener('click', (e) => {
        const a = e.target.closest('[data-sib]'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault(); const i = +a.dataset.sib, ci = sibs.findIndex((s) => s.current); goSibling(i, i > ci ? 1 : -1);
      });
      // prefetch a sibling page only when the shopper reaches for that chip (no 4-7 page downloads on first load)
      const pf = new Set(), pre = (e) => { const a = e.target.closest && e.target.closest('[data-sib]'); if (!a || pf.has(a.href) || a.getAttribute('aria-current')) return; pf.add(a.href); const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l); };
      ['pointerenter', 'touchstart', 'focusin'].forEach((t) => $('[data-b-shapes]').addEventListener(t, pre, { passive: true, capture: true }));
    }
    /* Stage gestures (UPDATE 13, owner bug): a swipe/drag ONLY moves between the photos of the CURRENT selection
       (ring angles, then "On the hand"). It never changes carat, gold, shape or product; shapes change only via the picker.
       Any pointer that travels > 8 px is a drag: the click that follows is swallowed, so a mouse drag can't follow a link. */
    const vit = $('[data-b-vit]');
    let x0 = null, y0 = null, moved = 0, dragged = false;
    vit.addEventListener('dragstart', (e) => e.preventDefault());
    root.addEventListener('pointerdown', (e) => { moved = 0; dragged = false; x0 = e.clientX; y0 = e.clientY; }, true);
    root.addEventListener('pointermove', (e) => { if (x0 == null) return; moved = Math.max(moved, Math.abs(e.clientX - x0), Math.abs(e.clientY - y0)); if (moved > 8) dragged = true; }, true);
    root.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    const photos = () => { const imgs = gallery().filter((x) => x.t === 'img').map((_, i) => ({ view: 'ring', gi: i })); if (modes.includes('hand')) imgs.push({ view: 'hand', gi: 0 }); return imgs; };
    const photoIndex = (list) => list.findIndex((ph) => ph.view === S.view && (ph.view !== 'ring' || ph.gi === S.gi));
    function goPhoto(step) {
      const list = photos();
      if (S.tt) { ttLeave(); showRing(step); opt('view_360', 'off'); return; }   // UPDATE 18: a swipe leaves the 360 for the photo the shopper left
      if (list.length < 2) return;
      let k = photoIndex(list); if (k < 0) k = 0;
      const nx = list[(k + step + list.length) % list.length];
      if (nx.view === 'ring') { if (S.view !== 'ring') setView('ring', true); S.gi = nx.gi; showRing(step); } else setView(nx.view, true);
      opt('photo', nx.view + (nx.view === 'ring' ? nx.gi : ''));
    }
    vit.addEventListener('pointerup', (e) => {
      if (x0 == null || S.view === 'compare') return; const dx = e.clientX - x0, dy = e.clientY - y0;
      if (e.target.closest && e.target.closest('.gzb-360bar')) return;   // the 360 / play buttons handle their own taps
      if (S.tt && S.view === 'ring' && !dragged && Math.abs(dx) < 10 && Math.abs(dy) < 10) { ttPlay.click(); return; }   // tap on the 360 = play / pause
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { goPhoto(dx < 0 ? 1 : -1); return; }   // swipe = next/previous photo of THIS selection
      if (!dragged && S.view === 'ring' && Math.abs(dx) < 10 && Math.abs(dy) < 10) { const g = gallery().filter((x) => x.t === 'img'); if (g.length > 1) { S.gi = (S.gi + 1) % g.length; showRing(); opt('ring_view', S.gi); } }   // tap = next angle
    });
    function setCarat(n) { const v = caratVal(n); if (!v || v === sel[iC]) return; sel[iC] = v; render(); opt('center_carat', v); }
    let slideT;
    if (carats.length > 1) {
      $('[data-b-range]').addEventListener('input', (e) => { const c = carats[+e.target.value]; if (c && c.v !== sel[iC]) { sel[iC] = c.v; render(); clearTimeout(slideT); slideT = setTimeout(() => opt('center_carat', c.v), 600); } });
      $('[data-b-ticks]').addEventListener('click', (e) => { const b = e.target.closest('[data-ct]'); if (b) setCarat(+b.dataset.ct); });
    }
    $('[data-b-dots]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-c]'), m = curMetal(); if (!b || !m || b.dataset.c === m.c) return;
      const v = metalValue(b.dataset.c, m.k); if (!v) return;
      sel[iM] = v; b.classList.remove('shine'); void b.offsetWidth; if (!reduce) b.classList.add('shine');
      render(); opt('metal', v);
    });
    $('[data-b-karat]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-k]'), m = curMetal(); if (!b || !m || b.dataset.k === m.k) return;
      const v = metalValue(m.c, b.dataset.k); if (!v) return; sel[iM] = v; render(); opt('metal', v);
    });
    $('[data-b-views]').addEventListener('click', (e) => { const b = e.target.closest('[data-view]'); if (b && b.dataset.view !== S.view) setView(b.dataset.view, true); });
    $('[data-b-cmp]').addEventListener('click', (e) => { const b = e.target.closest('[data-ct]'); if (b) { setCarat(+b.dataset.ct); if (modes.includes('hand')) setView('hand', true); } });
    $('[data-b-qual]').addEventListener('click', (e) => { const b = e.target.closest('[data-q]'); if (b && !b.disabled && b.dataset.q !== sel[iQ]) { sel[iQ] = b.dataset.q; render(); opt('quality', b.dataset.q); } });
    $('[data-b-other]').addEventListener('click', (e) => { const b = e.target.closest('[data-oi]'); if (b && !b.disabled) { sel[+b.dataset.oi] = b.dataset.ov; render(); opt(P.options[+b.dataset.oi], b.dataset.ov); } });
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-b-sizes] [data-size]');
      if (b) { S.size = b.dataset.size; $('[data-b-cart-err]').textContent = ''; const st = $('[data-b-sizestep]'); if (st) st.classList.remove('is-nudge'); render({ noUrl: true }); opt('ring_size', S.size); }
      const lead = e.target.closest('[data-b-lead]');
      if (lead) track('generate_lead', { method: lead.dataset.bLead, link_text: lead.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) });
      const chat = e.target.closest('[data-b-chat]');
      if (chat) openChat();
    });

    // quality: one line that opens the three plain-English tiers
    $('[data-b-qline]').addEventListener('click', () => { const pnl = $('[data-b-qpanel]'), open = pnl.hidden; pnl.hidden = !open; $('[data-b-qline]').setAttribute('aria-expanded', String(open)); if (open) opt('quality_panel', 'open'); });

    // ring size guide (in-page dialog)
    const sg = $('[data-b-sg]'); let sgBack = null;
    const sgOpen = () => { sgBack = document.activeElement; sg.classList.add('is-open'); setTimeout(() => $('.gzb-sg__panel', sg).focus(), 60); opt('size_guide', 'open'); };
    const sgClose = () => { sg.classList.remove('is-open'); if (sgBack && sgBack.focus) sgBack.focus(); };
    root.addEventListener('click', (e) => { if (e.target.closest('[data-b-sg-open]')) sgOpen(); if (e.target.closest('[data-sg-close]')) sgClose(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sg.classList.contains('is-open')) { e.stopPropagation(); sgClose(); } }, true);

    // UPDATE 23: find-her-size helper (ruler on a ring she wears; paper strip; chart). No on-screen measuring (screens vary).
    const FS = { dia: 16.5, circ: 52 };
    const sizeOf = (d) => { const v = Math.round(((d - 11.63) / 0.8128) * 2) / 2; return Math.max(+ST.sizeMin || 3, Math.min(+ST.sizeMax || 10, v)); };
    const fmtS = (v) => (v % 1 ? v.toFixed(1) : String(v));
    function fsDraw() {
      $('[data-fs-mm]', sg).textContent = FS.dia.toFixed(1) + ' mm'; $('[data-fs-size]', sg).textContent = 'Size ' + fmtS(sizeOf(FS.dia));
      $('[data-fs-circ]', sg).textContent = FS.circ.toFixed(0) + ' mm'; $('[data-fs-csize]', sg).textContent = 'Size ' + fmtS(sizeOf(FS.circ / Math.PI));
    }
    function fsTab(k) {
      $$('[data-fs-tab]', sg).forEach((t) => t.setAttribute('aria-selected', String(t.dataset.fsTab === k)));
      $$('[data-fs-pane]', sg).forEach((p) => { p.hidden = p.dataset.fsPane !== k; });
      opt('size_helper', k);
    }
    sg.addEventListener('click', (e) => {
      const t = e.target.closest('[data-fs-tab]'); if (t) { fsTab(t.dataset.fsTab); return; }
      const st = e.target.closest('[data-fs-step]'); if (st) { FS.dia = Math.max(13, Math.min(22, +(FS.dia + 0.5 * +st.dataset.fsStep).toFixed(1))); fsDraw(); return; }
      const cst = e.target.closest('[data-fs-cstep]'); if (cst) { FS.circ = Math.max(41, Math.min(69, FS.circ + +cst.dataset.fsCstep)); fsDraw(); return; }
      const u = e.target.closest('[data-fs-use]');
      if (u) { const v = u.dataset.fsUse === 'strip' ? sizeOf(FS.circ / Math.PI) : sizeOf(FS.dia); S.size = String(v); opt('ring_size', S.size + ' (helper ' + u.dataset.fsUse + ')'); render({ noUrl: true }); sgClose(); }
    });
    if (sg) fsDraw();

    // details drawer
    function setDrawer(open) { const d = $('[data-b-drawer]'); if (!d) { const r = $('[data-b-more] details'); if (r) r.open = !!open; return; } d.dataset.open = String(open); $('[data-b-drawer-btn]').setAttribute('aria-expanded', String(open)); }
    const dBtn = $('[data-b-drawer-btn]'); if (dBtn) dBtn.addEventListener('click', () => { const o = $('[data-b-drawer]').dataset.open !== 'true'; setDrawer(o); if (o) opt('details', 'open'); });
    root.addEventListener('toggle', (e) => { const d = e.target; if (!d.open || !d.matches) return; if (d.matches('[data-b-engr]')) { opt('engraving', 'open'); setTimeout(() => { const i = $('[data-b-engraving]'); if (i) i.focus({ preventScroll: true }); }, 50); } else if (d.matches('.gzb-more__row')) opt('details', (d.querySelector('summary') || {}).textContent || 'open'); }, true);   // UPDATE 23b

    // chat (Crisp). The site-wide gz-lead-tracking also fires lead_chat_open on Crisp's own open event.
    const crisp = () => { window.$crisp = window.$crisp || []; return window.$crisp; };
    if (ST.hideChatBubble) { crisp().push(['do', 'chat:hide']); crisp().push(['on', 'chat:closed', () => { crisp().push(['do', 'chat:hide']); }]); }
    function openChat() {
      track('generate_lead', { method: 'chat' });
      const msg = `Hi! I have a question about the ${P.design}: ${cfgText(true)}. ${productLink()}`;
      if (window.$crisp) { crisp().push(['do', 'chat:show']); crisp().push(['set', 'message:text', [msg]]); crisp().push(['do', 'chat:open']); }
      else location.href = smsHref();
    }

    // add to bag -> size sheet (the only required choice without a default)
    const sheet = $('[data-b-sheet]');
    let lastFocus = null;
    function openSheet() { lastFocus = document.activeElement; sheet.classList.add('is-open'); opt('size_sheet', 'open'); setTimeout(() => { const b = $('[data-b-sheet] [data-size="6.5"]') || $('[data-b-sheet] [data-size]'); if (b) b.focus(); }, 60); }
    function closeSheet() { sheet.classList.remove('is-open'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) closeSheet(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
    $$('[data-b-atc]').forEach((b) => b.addEventListener('click', () => { if (needPick()) nudgeSize(); else addToBag(); }));   // UPDATE 23: point at step 5, no surprise sheet
    $('[data-b-sheet-go]').addEventListener('click', () => { if (S.size) addToBag(); });
    async function addToBag() {
      if (!cur || !cur.available) return;
      if (needPick()) { nudgeSize(); return; }
      const props = {};
      if (ST.needSize) props['Ring size'] = String(S.size);
      const eng = $('[data-b-engraving]'); if (eng && eng.value.trim()) props.Engraving = eng.value.trim();
      // UPDATE 24: photos of exactly this ring for the jeweler/staff. "_" names = hidden from the customer (cart, checkout, emails), shown on the admin order.
      try {
        const abs = (u) => (u ? String(u).replace(/^\/\//, 'https://') : '');
        const gImg = gallery().find((x) => x.t === 'img'); if (gImg) props['_Ring photo'] = abs(gImg.src);
        const n = curCarat(), h = n != null ? handFor(n, cur ? vC(cur) : null) : null;
        if (h && h.src && h.ct === n) props['_On hand photo'] = abs(h.src);
      } catch (e) { /* never block add to bag */ }
      const btns = $$('[data-b-atc]').concat([$('[data-b-sheet-go]')]); btns.forEach((b) => { b.disabled = true; });
      const err = $('[data-b-cart-err]'); err.textContent = '';
      try {
        const r = await fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: cur.id, quantity: 1, properties: props }] }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to bag. Please try again or text us.'); }
        track('add_to_cart', { ring_size: props['Ring size'] || '' });
        const t = $('[data-b-toast]'); t.textContent = `Added to bag: ${P.design}, ${cfgText(false)}${props['Ring size'] ? ', size ' + S.size : ''}.`; t.classList.add('is-on');
        setTimeout(() => { location.href = shopRoot + 'cart'; }, 450);
      } catch (ex) {
        err.textContent = ex.message; if (!sheet.classList.contains('is-open')) openSheet();
        btns.forEach((b) => { b.disabled = false; }); render({ noUrl: true });
      }
    }

    // sticky bar height -> page padding + toast offset
    const bar = $('[data-b-bar]');
    const syncBar = () => document.documentElement.style.setProperty('--gzb-bar-h', bar.offsetHeight + 'px');
    syncBar(); if (window.ResizeObserver) new ResizeObserver(syncBar).observe(bar); else addEventListener('resize', syncBar);
    addEventListener('resize', () => { $('[data-b-bar-cfg]').textContent = barCfg(); });

    // the in-page Add to bag replaces the sticky bar while it is on screen (no duplicate buttons):
    // phone = the price block under the choices; desktop (UPDATE 17, Option A) = the button under the price in the side column
    const buy = $('[data-b-buy]'), sideAtc = $('[data-b-side-buy] [data-b-atc]');
    let buyOn = false, sideOn = false;
    const tuck = () => bar.classList.toggle('is-tucked', desk() ? sideOn && !bar.contains(document.activeElement) : buyOn);
    if (window.IntersectionObserver) {
      if (buy) new IntersectionObserver((es) => { es.forEach((en) => { buyOn = en.isIntersecting; }); tuck(); }, { threshold: 0.2 }).observe(buy);
      if (sideAtc) {
        const head = document.querySelector('.main-header, header.site-header, #shopify-section-header header');   // desktop header stays on screen: a button under it is out of view
        const hh = head ? Math.round(head.getBoundingClientRect().height) : 0;
        new IntersectionObserver((es) => { es.forEach((en) => { sideOn = en.isIntersecting; }); tuck(); }, { rootMargin: `-${hh}px 0px 0px 0px` }).observe(sideAtc);
        bar.addEventListener('focusin', tuck); bar.addEventListener('focusout', () => setTimeout(tuck, 0));   // keyboard focus in the bar brings it up (desktop)
      }
      const mq = matchMedia('(min-width: 1024px)'); if (mq.addEventListener) mq.addEventListener('change', tuck);
    }

    // arriving from another shape: land on the photo, not the very top of the page
    function toStage() {
      const head = document.querySelector('.main-header, header.site-header, #shopify-section-header header');
      const off = head && getComputedStyle(head).position === 'fixed' || (head && getComputedStyle(head).position === 'sticky') ? head.offsetHeight : 0;
      const el = $('[data-b-center]'), y = el.getBoundingClientRect().top + scrollY - off - 8;
      window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }
    // UPDATE 23d: no auto-jump after a shape change (it landed mid-page under the pinned header). A new shape opens at the top, like any page.
    // if (qs.get('er_ct') || qs.get('er_m') || qs.get('er_v')) { requestAnimationFrame(toStage); setTimeout(toStage, 400); }

    // test hooks (harness + QA screenshots)
    window.__gzbPDP = { S, sel, render, setView, setDrawer, openSheet, closeSheet, setCarat, modes, sibs, track, tt: () => { const t = ttCur(); return { on: S.tt, paused: S.ttPaused, src: video && video.getAttribute('src'), colours: Object.keys(TT), legacy: !ttByColour && !!(P.turntable && P.turntable.src), shown: t ? t.c || null : null, from: S.ttFrom || null, caption: S.tt && t ? ttNoteText(t) : '' }; } };

    render({ noUrl: !J.urlVariant && !qs.get('er_ct') });
    setView(modes.includes(qs.get('er_v')) ? qs.get('er_v') : 'ring', false);
    track('view_item');
  }

  function boot() {
    document.querySelectorAll('[data-gz-er-pdp]').forEach((r) => {
      if (r.dataset.ready) return; r.dataset.ready = '1';
      try { init(r); } catch (e) { console.error('gz-er-pdp', e); }
    });
  }
  if (window.GZ) boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
